import { render, staticRenderFns } from "./CardOptions.vue?vue&type=template&id=956cb1d0&scoped=true"
import script from "./CardOptions.vue?vue&type=script&lang=js"
export * from "./CardOptions.vue?vue&type=script&lang=js"
import style0 from "./CardOptions.vue?vue&type=style&index=0&id=956cb1d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956cb1d0",
  null
  
)

export default component.exports